{ Jadelet, Modal } from @danielx/dui

Template := Jadelet.exec """
  aside.meter-picker
    @buttons
"""

ButtonTemplate := Jadelet.exec """
  button(@click class=@active) @meter
"""

PickerTemplate := Jadelet.exec """
  section.time-signature
    h2 Time Signature
    button.close(click=@close) X
    @rows
"""

RowTemplate := Jadelet.exec """
  div @items
"""

export MeterPicker := (player: Player) ->

  choices := [
    "4/4"
    "3/4"
  ]

  showAdvancedPicker := ->
    Modal.show PickerTemplate
      close: ->
        Modal.hide()

      rows: ->
        ([
          [2,  [2, 3, 4]]
          [4,  [2, 3, 4,  5,  6,  7]]
          [8,  [3, 4, 5,  6,  7,  8,  9, 10, 11, 13, 15]]
          [16, [5, 7, 9, 10, 11, 13, 14, 15, 17, 18, 19]]
        ] as const).map ([denominator, numerators]) ->
          RowTemplate
            items: ->
              numerators.map (numerator) ->
                meter := `${numerator}/${denominator}`

                ButtonTemplate
                  active: ->
                    "active" if meter is player.timeSignature()
                  click: ->
                    player.timeSignature meter
                  meter: meter

  self :=
    buttons: ->
      buttons .= choices.map (meter, i) ->
        ButtonTemplate
          active: ->
            "active" if meter is player.timeSignature()
          click: ->
            player.timeSignature meter

          meter: meter

      if player.purchased()
        buttons = buttons.concat [
          ButtonTemplate
            active: false
            click: ->
              showAdvancedPicker()
            meter: "*/*"
        ]

      return buttons

    element: null as! HTMLElement

  self.element = Template self

  return self

export default MeterPicker
